import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import styled from 'styled-components';
import _get from 'lodash/get';
import {
  PracticeFooterBarMobile,
  PBMobileSelectedItem,
  ProgressBarItem,
  ProgressBarCircle,
  ProgressBarLine,
  PracticeFooterBar,
  ProgressBarWrapper,
  MobileOnly,
  DesktopOnly,
} from '../PracticePage/PracticePage.style';
import { NavigationHeaderWrap } from '../QuestionAssets/QuestionAssets.style';
import { ContentRow, MainContent } from '../Atoms/ResizableTray/ResizableTray.style';
import ResizableTray from '../Atoms/ResizableTray';
import AnswersTrayContent from './AnswersTrayContent';

import QuestionAssets from '../../containers/QuestionAssets';
import PracticeReviewItem from '../PracticeReviewItem';
import AnswerExplanation from '../../containers/AnswerExplanation/AnswerExplanation';
import GroupActivityQuestionItem from '../../containers/GroupActivityContent/GroupActivityQuestionItem';

class GroupActivityContentItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      answeredQuestions: {},
      showAnswers: false,
      isQuestionModalOpen: false,
      isOpenSideBar: false,
    };
  }

  toggleQuestionModal = () => {
    this.setState(({ isQuestionModalOpen }) => ({
      isQuestionModalOpen: !isQuestionModalOpen,
    }));
  };

  toggleExplanationSideBar = () => {
    this.setState(({ isOpenSideBar }) => ({
      isOpenSideBar: !isOpenSideBar,
    }));
  };

  hideAnswersOnQuestionChange = (handler) => () =>
    this.setState({ showAnswers: false }, handler);

  renderProgressBar = (currentQuestion, index) => {
    const { questionSelected, selectQuestion, questions, status } = this.props;
    const numberQuestion = currentQuestion ? questions.length : null;
    const isSelected = currentQuestion ? questionSelected >= index : true;
    const isActive = currentQuestion ? questionSelected > index : true;
    const isQuestionAnswered =
      Boolean(this.state.answeredQuestions[questions[index]?.id]) &&
      questionSelected >= index;
    const isProgressBarCircleDisabled = [1, 2].some((value) => value === +status);

    return (
      <ProgressBarItem
        isActive={isActive}
        isAnswered={isQuestionAnswered}
        isSelected={isSelected}
        widthValue={numberQuestion}
        firstItem={!index}
        key={index}
      >
        {currentQuestion ? (
          <>
            <ProgressBarLine />
            <ProgressBarCircle
              onClick={
                isProgressBarCircleDisabled
                  ? undefined
                  : this.hideAnswersOnQuestionChange(selectQuestion(index, true))
              }
              disabled={isProgressBarCircleDisabled}
            />
          </>
        ) : (
          <PBMobileSelectedItem onClick={this.toggleQuestionModal}>
            <ProgressBarCircle />
            {`Question ${questionSelected + 1}`}
          </PBMobileSelectedItem>
        )}
      </ProgressBarItem>
    );
  };

  renderStudentQuestion = () => {
    const {
      questions,
      scores,
      questionSelected,
      nextQuestion,
      prevQuestion,
      openReportErrorModal,
      status,
      startTime,
      answers,
      history,
      nextStage,
      courseId,
      sectionId,
      subjectId,
      unitId,
      lessonId,
      currentGroup,
      correctAnswer,
      groupId,
      onlineResponseId,
      userId,
      isTeacher,
      currentGroupStudents,
      hideModal,
      totalDuration,
      setSelectedQuestion,
    } = this.props;

    const questionSelectedObj = questions[questionSelected];
    const totalQuestions = questions.length;
    const questionOrder = questionSelectedObj.order || null;
    const explanation = _get(correctAnswer, 'explanation', {});
    const questionId = _get(questionSelectedObj, 'id');
    const score = scores.find((score) => score.exam_question.id == questionId)?.score;
    const groupStatus = status === 'review' ? status : parseInt(status);
    return (
      <OnlineReviewItemContainer>
        <GroupActivityQuestionItem
          answeredQuestions={this.state.answeredQuestions}
          questionSelected={questionSelectedObj}
          totalQuestions={totalQuestions}
          prevQuestion={prevQuestion}
          index={questionSelected}
          order={questionOrder}
          startTime={startTime}
          toggleExplanationSideBar={this.toggleExplanationSideBar}
          openReportErrorModal={openReportErrorModal}
          questionId={questionId}
          nextQuestion={nextQuestion}
          setSelectedQuestion={setSelectedQuestion}
          answers={answers}
          totalDuration={totalDuration}
          status={groupStatus}
          history={history}
          nextStage={nextStage}
          correctChoice={correctAnswer?.correct_choices}
          isTeacher={isTeacher}
          hideModal={hideModal}
          score={score}
          onAnswerQuestion={({ questionSelected, answer }) => {
            if (status !== 'review') {
              this.setState({
                answeredQuestions: {
                  ...this.state.answeredQuestions,
                  [questionSelected.id]: answer,
                },
              });
            }
          }}
          isGroupActivity
          questions={questions}
          numberOfQuestions={questions.length || 3}
          {...{
            courseId,
            sectionId,
            subjectId,
            unitId,
            lessonId,
            currentGroup,
            groupId,
            onlineResponseId,
            userId,
            currentGroupStudents,
          }}
        />
        {status === 'review' && (
          <DesktopOnly>
            <AnswerExplanation
              explanation={explanation}
              openReportErrorModal={openReportErrorModal}
              questionId={questionId}
              unSetHeight
            />
          </DesktopOnly>
        )}
      </OnlineReviewItemContainer>
    );
  };

  renderReviewQuestion = () => {
    const {
      questions,
      questionSelected,
      nextQuestion,
      prevQuestion,
      openReportErrorModal,
      status,
      isTeacher,
    } = this.props;

    const questionSelectedObj = questions[questionSelected];
    const totalQuestions = questions.length;
    const questionOrder = questionSelectedObj.order || null;
    const questionId = _get(questionSelectedObj, 'id');

    return (
      <OnlineReviewItemContainer>
        <PracticeReviewItem
          questionSelected={{
            ...questionSelectedObj,
            exam_question: { question: questionSelectedObj.question },
          }}
          totalQuestions={totalQuestions}
          nextQuestion={this.hideAnswersOnQuestionChange(nextQuestion)}
          toggleExplanationSideBar={this.toggleExplanationSideBar}
          prevQuestion={this.hideAnswersOnQuestionChange(prevQuestion)}
          index={questionSelected}
          order={questionOrder}
          openReportErrorModal={openReportErrorModal}
          questionId={questionId}
          isTeacher={isTeacher}
          onlineQuestion
          isGroupActivity
          showAnswers={this.state.showAnswers}
        />
      </OnlineReviewItemContainer>
    );
  };

  render() {
    const {
      questions,
      isActivityNavigation,
      questionSelected,
      isTeacher,
      bellringerMode,
      openReportErrorModal,
      displayGrammarHelper,
      status,
    } = this.props;
    const totalQuestions = questions.length;

    if (totalQuestions === 0) return null;

    const questionSelectedObj = questions[questionSelected];
    const assets = _get(questionSelectedObj, 'question.shared_assets', []);
    const explanation = _get(questionSelectedObj, 'explanation', {});
    const questionId = _get(questionSelectedObj, 'id');
    const answeredByStudent = questionSelectedObj.studentAnswered;
    const answeredByGroup = questionSelectedObj.groupAnswered;

    return (
      <>
        <ContentRow>
          {assets.length > 0 && (
            <ResizableTray
              id="resource"
              side="left"
              label="Resource"
              defaultWidth={320}
              minWidth={200}
              maxWidth={560}
              defaultOpen
            >
              <QuestionAssets
                hasFooter
                assets={assets}
                displayGrammarHelper={displayGrammarHelper}
                questionSelected={questionSelected}
                openReportErrorModal={openReportErrorModal}
                questionId={questionId}
                trayMode
                fillHeight
              />
            </ResizableTray>
          )}

          <MainContent>
            <MobileOnly>
              {assets.length > 0 ? (
                <Tabs defaultIndex={0}>
                  <NavigationHeaderWrap>
                    <TabList>
                      <Tab>Assets</Tab>
                      <Tab>Question</Tab>
                    </TabList>
                  </NavigationHeaderWrap>
                  <TabPanel>
                    <QuestionAssets
                      hasFooter
                      assets={assets}
                      displayGrammarHelper={displayGrammarHelper}
                      questionSelected={questionSelected}
                      openReportErrorModal={openReportErrorModal}
                      questionId={questionId}
                      trayMode
                    />
                  </TabPanel>
                  <TabPanel>
                    {isTeacher ? this.renderReviewQuestion() : this.renderStudentQuestion()}
                    {this.state.isOpenSideBar && (
                      <AnswerExplanation
                        explanation={explanation}
                        openReportErrorModal={openReportErrorModal}
                        questionId={questionId}
                        unSetHeight
                      />
                    )}
                  </TabPanel>
                </Tabs>
              ) : (
                <>
                  {isTeacher ? this.renderReviewQuestion() : this.renderStudentQuestion()}
                  {this.state.isOpenSideBar && (
                    <AnswerExplanation
                      explanation={explanation}
                      openReportErrorModal={openReportErrorModal}
                      questionId={questionId}
                      unSetHeight
                    />
                  )}
                </>
              )}
            </MobileOnly>
            <DesktopOnly>
              {isTeacher ? this.renderReviewQuestion() : this.renderStudentQuestion()}
            </DesktopOnly>
          </MainContent>

          {isTeacher && (
            <ResizableTray
              id="answers"
              side="right"
              label="Answers"
              defaultWidth={380}
              minWidth={240}
              maxWidth={600}
              defaultOpen={!bellringerMode}
            >
              <AnswersTrayContent
                showAnswers={this.state.showAnswers}
                onToggleAnswers={() => this.setState({ showAnswers: !this.state.showAnswers })}
                bellringerMode={bellringerMode}
                explanation={explanation}
                questionId={questionId}
                status={status}
                openReportErrorModal={openReportErrorModal}
                answeredByGroup={answeredByGroup}
                answeredByStudent={answeredByStudent}
              />
            </ResizableTray>
          )}
        </ContentRow>
        <PracticeFooterBar>
          <ProgressBarWrapper>{questions.map(this.renderProgressBar)}</ProgressBarWrapper>
          <PracticeFooterBarMobile>
            <ProgressBarWrapper>{this.renderProgressBar()}</ProgressBarWrapper>
          </PracticeFooterBarMobile>
        </PracticeFooterBar>
      </>
    );
  }
}
const OnlineReviewItemContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  @media (max-width: 768px) {
    width: 90%;
    margin: 0 auto;
  }
`;
export default GroupActivityContentItem;
